<template>
  <footer class="footer">
    <div class="container">
      Made by <a href="https://www.reddit.com/user/phasmophilia">/u/phasmophilia</a>
    </div>
  </footer>
</template>

<style lang="scss">
@import '@/utils.scss';
@import 'bulma/sass/layout/footer';
@import 'bulma/sass/elements/container';
</style>
